var _g, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatRadar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.112 4.106c-1.184-1.166-2.692-1.96-4.333-2.281s-3.343-.157-4.89.474-2.868 1.699-3.798 3.07S1.665 8.351 1.665 10s.496 3.26 1.426 4.631 2.252 2.439 3.798 3.07 3.248.796 4.89.474 3.15-1.115 4.333-2.281L10.128 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.89 6.464c-.728-.699-1.656-1.176-2.667-1.369a5.41 5.41 0 0 0-3.009.285c-.952.379-1.765 1.019-2.337 1.842A4.86 4.86 0 0 0 4.999 10a4.86 4.86 0 0 0 .878 2.778c.572.822 1.386 1.463 2.337 1.842a5.41 5.41 0 0 0 3.009.285c1.01-.193 1.714-.54 2.442-1.24L10.207 10"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.667,
    transform: "matrix(1 0 0 -1 10 9.99999)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRadar);
export default __webpack_public_path__ + "static/media/chat-radar.58a95bd4.svg";
export { ForwardRef as ReactComponent };